/**
 * Main JS file for project.
 *
 * Using jQuery for limited interations.
 */

/* global $ */
'use strict';

// Dependencies
import utilsFn from './utils.js';
import _ from 'underscore';
import Navigo from 'navigo';
import Headroom from 'headroom.js';

// Setup utils
const utils = utilsFn({});

// Common vars
let titleSuffix = 'Design by Community - Case Studies of Resiliency';

// Common elements
let $pages = $('.pages');
let $allPages = $('.pages .page');
let $nav = $('nav');
let $navLinks = $('nav a');
let $skipContent = $('.to-main-content');
let $announcer = $('#announcer');
let $topNav = $('.fixed-nav');
let $topNavLimit = $('.pages');
let $ideaForm = $('.idea-form');
let $thank = $('.thank-you-message');
let $resetForm = $('.reset-form');
let $fixedTitle = $('.fixed-title');
let $toTop = $('.to-top');

// Routing
const router = new Navigo(null, true, '#!');
const defaultPage = 'fourth-avenue-transit-hub';

// Handle pages
router
  .on({
    '/:page': (params) => {
      showPage(params.page);
    },
    '*': showPage
  })
  .resolve();

// Show a specific page
function showPage(page) {
  // Check if there is a ?page
  if (!page && utils.query && utils.query.page) {
    page = utils.query.page;
  }

  // See if there is a valid page
  page = page || 'default';
  let $page = $('.page-' + page);

  if (!$page || !$page.length) {
    // TODO: This screws up the Back button
    return router.navigate('/');
  }

  // Fade out pages
  $allPages.fadeOut('fast', () => {
    setTimeout(() => {
      $page.fadeIn('fast');
    }, 200);
  });

  // Update title
  let title = $page.find('h1').text();
  document.title = title + ' | ' + titleSuffix;

  // Announce to screen reader
  announce('New page loaded: ' + title);

  // Update nav
  $navLinks.removeClass('active');
  $nav.find('[data-link="' + (page === 'default' ? defaultPage : page) + '"]').addClass('active');

  // Update fixed nav
  $fixedTitle.text(title);

  // Pause all players
  $('.page .audio-player').each(function() {
    let $player = $(this);
    $player[0].contentWindow.postMessage('{ "method": "pause" }', '*');
  });

  // Tell GA about it
  utils.gaPageUpdate();
}

// For anchor tags, we have to get around this because the router
// takes it over
$skipContent.on('click', (e) => {
  e.preventDefault();
  $('#main-content').attr('tabindex', '-1').focus();
});

// Handle fixed navigation.  Headroom has a great default interaction,
// but it assumes the nav is actually a top nav, and we don't want it
// at top.
let headroom  = new Headroom($topNav[0]);
headroom.init({
  offset: 0,
  tolerance: 10
});
let checkTopNav = _.debounce(() => {
  let s = $(window).scrollTop();
  let e = $topNavLimit.offset().top;
  let h = $topNav.hasClass('force-hide');

  if (!h && s <= e) {
    $topNav.addClass('force-hide');
  }
  else if (h && s > e) {
    $topNav.removeClass('force-hide');
  }
}, 100);
checkTopNav();
$(window).on('scroll', checkTopNav);

// Scroll to top link
$toTop.on('click', (e) => {
  e.preventDefault();
  utils.goTo($('.project-header'));
});

// Handle idea submission  (we don't know if it was successful or not?)
$ideaForm.on('submit', function(e) {
  resetForm();

  // Validation
  let valid = true;
  $ideaForm.find('input, textarea').each(function() {
    let $input = $(this);
    if ($input.attr('required') && !$input.val().trim()) {
      valid = false;

      $input.addClass('error').attr('aria-invalid', true);
      $ideaForm.find('[for="' + $input.attr('id') + '"]').addClass('error');
    }
  });

  // Email address
  let $email = $('#id_1933_5577-answer');
  if (!$email.val().trim().match(/\S+@\S+\.\S+/i)) {
    $email.addClass('error').attr('aria-invalid', true);
    $ideaForm.find('[for="' + $email.attr('id') + '"]').addClass('error');
    valid = false;
  }

  // Link
  let $link = $('#id_1933_5589-answer');
  if ($link.val().trim() && !$link.val().trim().match(/^(https|http|ftp|sftp)/i)) {
    $link.addClass('error').attr('aria-invalid', true);
    $ideaForm.find('[for="' + $link.attr('id') + '"]').addClass('error');
    valid = false;
  }

  if (!valid) {
    e.preventDefault();
    // We want this to be a little offset, but smoothscroll doesn't do that
    utils.goTo($('.page-submit-your-project'));

    // Tell screen readers whats up
    announce('There were some issues with your submission input.');
    return;
  }

  $thank.slideDown('slow').fadeIn('fast');
  $ideaForm.slideUp('fast');
});

// Reset form link
$resetForm.on('click', (e) => {
  e.preventDefault();
  resetForm(true);
});

// Reset form
function resetForm(resetView) {
  $ideaForm.find('*').removeClass('error');
  $ideaForm.find('input, textarea').removeAttr('aria-invalid');

  if (resetView) {
    $ideaForm.find('input, textarea').val('');
    $ideaForm.slideDown('slow');
    $thank.slideUp('fast').fadeOut('fast');
  }
}

// Anounce to screen readers
function announce(message) {
  $announcer.html(message);
  setTimeout(() => {
    $announcer.html('');
  }, 4000);
}



// WEBPACK FOOTER //
// ./app/index.js